import gql from 'graphql-tag'
export const CREATE_EVENT_CATEGORY_REQUEST = gql`
  mutation createEventCategoryRequest(
    $eventId: ID!
    $eventCategoryRequestInput: EventCategoryRequestInput!
  ) {
    createEventCategoryRequest(
      eventId: $eventId
      eventCategoryRequestInput: $eventCategoryRequestInput
    ) {
      token
    }
  }
`

export const GET_ACCREDITATION_INVITE = gql`
  query GetAccreditationInvite($token: String!) {
    getAccreditationInvite(token: $token) {
      event {
        from
        id
        numberOfZones
        attendeeFields
        applicationsOpen
        cover
        extraModules {
          mobileApp
          conferenceMobileApp
          expoMobileApp
          categoriesAndZones
          workshops
          ticketing
          scanEntries
        }
        organization {
          id
          publicName
          logo
          description
          facebookLink
          webLink
          email
        }
        title
        to
        managed
        slug
        coverImagePrimaryColor {
          r
          g
          b
        }
        location {
          id
          address1
          address2
          city
          postalCode
          state
          country
          venue
          latitude
          longitude
        }
        categories {
          color
          id
          name
          zones
        }
        workshops {
          id
          name
          to
          from
          lecturers {
            id
            fields
          }
          attendanceLimit
          attendees {
            id
          }
          attending
          unlimitedAttendance
          description
        }
        eventUtils {
          id
          inviteFormStyles
        }
      }
      category {
        color
        eventId
        id
        name
        zones
      }
    }
  }
`
